// extracted by mini-css-extract-plugin
export var centerText = "_d0-8";
export var container = "_d0-0";
export var doughnutContainer = "_d0-7";
export var legend = "_d0-a";
export var legendItemColorDisplay = "_d0-b";
export var legendItemLabel = "_d0-d";
export var legendItemValue = "_d0-c";
export var lg = "_d0-5";
export var maxWidth = "_d0-9";
export var md = "_d0-4";
export var responsive = "_d0-6";
export var sm = "_d0-3";
export var xs = "_d0-2";
export var xxs = "_d0-1";